export default __webpack_public_path__ + "static/media/sticker-8.deeb7dad.png";